import React from 'react'
import { Switch, Route } from 'react-router-dom'

import { CONFIG } from './constants'
import AuthWrapper from 'Hoc/AuthWrapper'

const renderRoute = ({ component, path, ...route }) => {
  const Comp = component
  return (
    <Route
      {...route}
      path={path}
      component={props => (
        <AuthWrapper>
          <Comp {...props} />
        </AuthWrapper>
      )}
    />
  )
}

const Routes = () => <Switch>{CONFIG.map(renderRoute)}</Switch>

export default Routes
